module.exports = __webpack_public_path__ + "img/slide_9.31265436.webp";